// Words inside the shared calculator form card on /dasha-calculator and
// /hi/dasha-calculator: submit and the calculation errors. Hindi is Devanagari
// (owner decision 2026-10-28, replacing the 2026-10-08 Hinglish rule), like the
// card's labels in BirthDetailsForm.i18n.ts; tests/hindi-register.test.ts
// guards the hi block (Devanagari) and the en block (no Devanagari). The page's
// hero, result and offer copy stay with the page.
export const DASHA_CARD_COPY = {
  en: {
    submit: "Calculate Dasha",
    unavailable: "Dasha calculation is unavailable right now. Please try again.",
    error: "Something went wrong",
  },
  hi: {
    submit: "दशा देखें",
    unavailable: "दशा की गणना अभी उपलब्ध नहीं है। कृपया दोबारा कोशिश करें।",
    error: "गणना नहीं हो पाई — कृपया दोबारा कोशिश करें।",
  },
} as const;
